import { Filter } from '@va/types/filters';
import React from 'react';

/** TODO Move types to @va/types/filters */

/** @deprecated use import from @va/types/filters */
export type FilterInputComponentRefType = {
  submit: () => void;
};

/** @deprecated use import from @va/types/filters */
export enum FilterOperators {
  is = 'is',
  isNot = 'isNot',
  contains = 'contains',
  doesNotContain = 'doesNotContain',
  startsWith = 'startsWith',
  endsWith = 'endsWith',
  isSet = 'isSet',
  isNotSet = 'isNotSet',

  between = 'between',
  notBetween = 'notBetween',
  notEqual = 'notEqual',
  equal = 'equal',
  greaterThan = 'greaterThan',
  greaterThanOrEqual = 'greaterThanOrEqual',
  lowerThan = 'lowerThan',
  lowerThanOrEqual = 'lowerThanOrEqual',
}

/** @deprecated use import from @va/types/filters */
export type CommonFilterParams<V, D> = {
  id: Filter['id'];
  label: Filter['label'];
  name: Filter['name'];
  operator?: Filter['operator'];
  operatorOptions?: Filter['operatorOptions'];
  appliedLabel?: Filter['appliedLabel'];
  valueMapper?: Filter['valueMapper'];
  values?: V[];
  inputProps?: D;
};

export enum FilterConnectors {
  and = 'and',
  or = 'or',
}
